// import "./modules/vendor/DragDropTouch.js"; // polyfill drag/drop on iOS

import { RenderApp } from "./modules/render.js";

RenderApp();
